import {
    toRecipientWellLabel,
    ccRecipientWellLabel,
    bccRecipientWellLabel,
} from './ReadOnlyRecipientWell.locstring.json';
import loc from 'owa-localize';
import ReadOnlyRecipient from './ReadOnlyRecipient';
import ReadOnlyRecipientViewState from '../store/schema/ReadOnlyRecipientViewState';
import { observer } from 'mobx-react';
import { RecipientType } from 'owa-recipient-types/lib/types/RecipientType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import * as React from 'react';

const styles = require('./ReadOnlyRecipientWell.scss');

export interface ReadOnlyRecipientWellProps {
    recipients: ReadOnlyRecipientViewState[];
    recipientType?: RecipientType;
    trailingComponent?: JSX.Element;
    includeEmailAddressByDefault?: boolean;
    wellLabelText?: string;
    renderSelf?: boolean;
    disableHover?: boolean;
    className?: string;
    allowRenderEmptyWell?: boolean;
    showPlainText?: boolean;
    recipientClassName?: string;
    recipientPersonaRef?: (ref: HTMLElement) => void;
}

@observer
export default class ReadOnlyRecipientWell extends React.Component<
    ReadOnlyRecipientWellProps,
    any
> {
    public recipientsParentRef: HTMLElement;

    render() {
        let {
            recipients,
            allowRenderEmptyWell,
            wellLabelText,
            recipientType,
            className,
            renderSelf,
            disableHover,
            trailingComponent,
            showPlainText,
            recipientPersonaRef,
        } = this.props;

        if (recipients && (allowRenderEmptyWell || recipients.length > 0)) {
            wellLabelText = wellLabelText || this.getWellLabelTextForRecipientType(recipientType);
            const wellLabel =
                recipientType != RecipientType.None ? (
                    <label className={styles.label}>{wellLabelText}</label>
                ) : null;
            return (
                <div className={className} key="readOnlyRecipientWellDiv">
                    {wellLabel}
                    <ul
                        className={styles.recipientsContainer}
                        ref={ref => (this.recipientsParentRef = ref)}>
                        {recipients.map((recipient, index) => {
                            const isSelf =
                                index == 0 &&
                                recipient.email.EmailAddress ==
                                    getUserConfiguration().SessionSettings.UserEmailAddress &&
                                renderSelf;

                            const isLast = index + 1 == recipients.length;

                            // Using an index as part of the key is sub-optimal, but the recipient array
                            // can contain duplicate data that has no other means of differentiating.
                            return (
                                <ReadOnlyRecipient
                                    recipientContentClassName={this.props.recipientClassName}
                                    key={`${recipient.email.EmailAddress}_${index}`}
                                    viewState={recipient}
                                    name={recipient.email.Name}
                                    emailAddress={recipient.email.EmailAddress}
                                    renderSelf={isSelf}
                                    isLast={isLast}
                                    disableHover={disableHover}
                                    mailBoxType={recipient.email.MailboxType}
                                    clientScenario="ReadOnlyRecipient"
                                    showPlainText={showPlainText}
                                    recipientPersonaRef={recipientPersonaRef}
                                />
                            );
                        })}
                    </ul>
                    {trailingComponent && (
                        <div
                            className={styles.wellTrailingComponent}
                            key="wellTrailingComponentDiv">
                            {trailingComponent}
                        </div>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }

    private getWellLabelTextForRecipientType(recipientType: RecipientType) {
        switch (recipientType) {
            case RecipientType.To:
                return loc(toRecipientWellLabel);
            case RecipientType.Cc:
                return loc(ccRecipientWellLabel);
            case RecipientType.Bcc:
                return loc(bccRecipientWellLabel);
            default:
                return '';
        }
    }
}
